export const setMeta = (seo) => {
  document.title = seo.title || 'Voyages A+'
  const metas = document.getElementsByTagName('meta')
  metas['og:title'].content = seo.title || 'Voyages A+'
  metas['description'].content =
    seo.description ||
    'Voyages A+ est une agence spécialisée dans le domaine des voyages éducatifs.'
  metas['og:description'].content =
    seo.description ||
    'Voyages A+ est une agence spécialisée dans le domaine des voyages éducatifs.'
  metas['og:image'].content = seo.image?.original || ''
  metas['og:type'].content = seo.type || 'website'
  metas['twitter:card'].content = seo.twitter || 'summary'
}
